// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-340aad42] .v--modal-box.v--modal {
  max-height: max-content;
  z-index: 99;
}
.custom-modal[data-v-340aad42] .v--modal-box.v--modal .header {
  padding: 15px 20px 0px 15px;
}
.custom-modal[data-v-340aad42] .v--modal-box.v--modal .body {
  max-height: fit-content;
  overflow-y: initial;
  padding: 0 24px;
}
.custom-modal[data-v-340aad42] .v--modal-box.v--modal .footer {
  position: relative;
  padding: 12px 20px 12px;
  right: 0;
}
.custom-modal[data-v-340aad42] .custom-input-text {
  line-height: 1em;
}
.custom-modal[data-v-340aad42] .custom-input-text .input {
  padding-top: 6px;
  padding-bottom: 3px;
}
.custom-modal[data-v-340aad42] .custom-input-text-placeholder.up {
  font-size: 0.8em;
}
.custom-modal[data-v-340aad42] .date-range-picker .date-range-content .date-picker {
  position: relative;
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .repeat-label {
  padding-left: 7px;
  font-size: 0.8em;
  color: var(--placeholder-color);
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .ddrepeat {
  width: 200px;
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .ddrepeat > .items {
  width: 284px;
  max-height: 160px;
  overflow-y: auto;
  z-index: 2;
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder {
  margin-left: 26px;
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder .reminder-label {
  padding-left: 7px;
  font-size: 0.8em;
  color: var(--placeholder-color);
}
.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder .ddreminder > .items {
  overflow-y: auto;
  max-height: 160px;
  width: 118px;
  z-index: 2;
}
.custom-modal[data-v-340aad42] .custom-dropdown span {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 89%;
  white-space: nowrap;
}
.scheduler[data-v-340aad42] {
  display: flex;
  flex-direction: column;
  color: var(--toolbtn-color);
  font-size: 16px;
  max-height: calc(var(--vh) * 80);
  overflow-y: auto;
  padding-top: 8px;
}
.scheduler[data-v-340aad42] .non-border-input {
  width: 100%;
  margin-bottom: 6px;
}
.scheduler .scheduler-item[data-v-340aad42] {
  display: flex;
  align-items: flex-end;
  height: auto;
  margin-top: 14px;
}
.scheduler .scheduler-item.checkBoxes[data-v-340aad42] {
  display: flex;
  padding-left: 4px;
}
.scheduler .scheduler-item.checkBoxes .checkBoxItem[data-v-340aad42] label.custom-checkbox {
  color: var(--font-color);
}
.scheduler .scheduler-item.checkBoxes .checkBoxItem[data-v-340aad42].disabled label.custom-checkbox {
  cursor: initial;
  color: var(--placeholder-color);
}
.scheduler .scheduler-item.checkBoxes .checkBoxItem.right[data-v-340aad42] {
  margin-left: 130px;
}
.scheduler .scheduler-item .note[data-v-340aad42] {
  padding-left: 7px;
  margin-top: 14px;
  color: var(--placeholder-color);
}
.scheduler .scheduler-item .editnote[data-v-340aad42] {
  white-space: pre-wrap;
  color: var(--font-color);
  background-color: var(--bg-color);
  border: 1px solid var(--list-item-bordercolor);
  padding: 8px;
  font-size: 14px;
  line-height: 1.4em;
  overflow-y: auto;
  resize: none;
  transition: all 0.2s;
  margin-top: -6px;
}
.scheduler .scheduler-item .editnote.disabled[data-v-340aad42] {
  color: var(--placeholder-color);
}
.scheduler .custom-input .custom-input-text[data-v-340aad42] {
  position: relative;
  width: 100%;
}
.scheduler .repeat-n-reminder[data-v-340aad42] {
  margin-top: 8px;
}
.scheduler .people[data-v-340aad42],
.scheduler .repeat[data-v-340aad42],
.scheduler .reminder[data-v-340aad42] {
  align-items: baseline !important;
}
.scheduler .repeat[data-v-340aad42],
.scheduler .reminder[data-v-340aad42] {
  flex-direction: column;
}
.scheduler .repeat-intervals[data-v-340aad42] {
  flex-direction: column;
  align-items: baseline;
  margin-top: 0px;
  color: var(--placeholder-color);
}
.scheduler .repeat-intervals .label-repeat-intervals[data-v-340aad42] {
  padding-left: 6px;
  margin-bottom: -12px;
  margin-top: 16px;
}
.scheduler .repeat-intervals .repeat-calendar[data-v-340aad42] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  padding-left: 24px;
  padding-bottom: 8px;
}
.scheduler .repeat-intervals .repeat-calendar[data-v-340aad42] .date-range-picker {
  width: 66%;
  z-index: 1;
}
.scheduler .repeat-intervals .repeat-calendar input.interval-input[data-v-340aad42] {
  color: var(--font-color);
  background-color: var(--bg-color);
  transition-property: all;
  transition-duration: 1s;
  border: none;
  border-bottom: 1px solid var(--list-item-bordercolor);
  padding-left: 6px;
  width: 36px;
}
.scheduler .repeat-intervals .repeat-calendar input.interval-input.disabled[data-v-340aad42] {
  color: var(--placeholder-color);
}
.scheduler .repeat-intervals .repeat-calendar input.interval-input[data-v-340aad42]:focus {
  outline: none;
  border-bottom: 1px solid var(--ref-link-color);
}
.scheduler .repeat-intervals .repeat-calendar .interval-value-label[data-v-340aad42] {
  margin-left: 8px;
  margin-right: 4px;
}
.scheduler .repeat-intervals .repeat-options[data-v-340aad42] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
}
.scheduler .repeat-options-ext[data-v-340aad42] {
  margin-top: 16px;
}
.scheduler .drpicker[data-v-340aad42] {
  height: 48px;
  margin-top: 6px;
}
.scheduler .people[data-v-340aad42] {
  flex-direction: column;
  margin-top: 0px;
  height: 48px;
}
.scheduler .people .people-label[data-v-340aad42] {
  padding-left: 6px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  font-size: 0.8em;
  color: var(--placeholder-color);
}
.scheduler .people .people-label .lbl-chosen-people[data-v-340aad42] {
  padding-left: 6px;
  height: 16px;
  font-size: 12px;
}
.scheduler .people .people-choose[data-v-340aad42] {
  display: flex;
  width: 100%;
}
.scheduler .people .people-choose input[data-v-340aad42] {
  color: var(--custom-textarea-color);
  transition-property: all;
  transition-duration: 1s;
  border: none;
  border-bottom: 1px solid var(--list-item-bordercolor);
  padding-left: 6px;
  width: 100%;
}
.scheduler .people .people-choose input.disabled[data-v-340aad42] {
  color: var(--placeholder-color);
}
.scheduler .people .people-choose input[data-v-340aad42]:focus {
  outline: none;
  border-bottom: 1px solid var(--ref-link-color);
}
.scheduler .people .lblBtn[data-v-340aad42] {
  cursor: pointer;
  font-size: 24px;
}
.scheduler .people .lblBtn.disabled[data-v-340aad42] {
  cursor: initial;
}
.scheduler .people .ctipeople[data-v-340aad42] {
  height: 28px;
  width: 383px;
  margin-right: 14px;
  background-color: inherit;
  color: inherit;
  outline: none;
}
.scheduler .subject .custom-input-text[data-v-340aad42] {
  width: 100%;
}
.scheduler .custom-input-text-placeholder[data-v-340aad42] {
  color: var(--modal-text-color) !important;
}
.scheduler .disabled[data-v-340aad42] {
  cursor: initial;
  color: var(--placeholder-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/integrations/MeetingScheduler.vue"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,iCAAiC;EACjC,8CAA8C;EAC9C,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,gCAAgC;AAClC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;EACrD,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;EACrD,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".custom-modal[data-v-340aad42] .v--modal-box.v--modal {\n  max-height: max-content;\n  z-index: 99;\n}\n.custom-modal[data-v-340aad42] .v--modal-box.v--modal .header {\n  padding: 15px 20px 0px 15px;\n}\n.custom-modal[data-v-340aad42] .v--modal-box.v--modal .body {\n  max-height: fit-content;\n  overflow-y: initial;\n  padding: 0 24px;\n}\n.custom-modal[data-v-340aad42] .v--modal-box.v--modal .footer {\n  position: relative;\n  padding: 12px 20px 12px;\n  right: 0;\n}\n.custom-modal[data-v-340aad42] .custom-input-text {\n  line-height: 1em;\n}\n.custom-modal[data-v-340aad42] .custom-input-text .input {\n  padding-top: 6px;\n  padding-bottom: 3px;\n}\n.custom-modal[data-v-340aad42] .custom-input-text-placeholder.up {\n  font-size: 0.8em;\n}\n.custom-modal[data-v-340aad42] .date-range-picker .date-range-content .date-picker {\n  position: relative;\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .repeat-label {\n  padding-left: 7px;\n  font-size: 0.8em;\n  color: var(--placeholder-color);\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .ddrepeat {\n  width: 200px;\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .repeat .ddrepeat > .items {\n  width: 284px;\n  max-height: 160px;\n  overflow-y: auto;\n  z-index: 2;\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder {\n  margin-left: 26px;\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder .reminder-label {\n  padding-left: 7px;\n  font-size: 0.8em;\n  color: var(--placeholder-color);\n}\n.custom-modal[data-v-340aad42] .repeat-n-reminder .reminder .ddreminder > .items {\n  overflow-y: auto;\n  max-height: 160px;\n  width: 118px;\n  z-index: 2;\n}\n.custom-modal[data-v-340aad42] .custom-dropdown span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 89%;\n  white-space: nowrap;\n}\n.scheduler[data-v-340aad42] {\n  display: flex;\n  flex-direction: column;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  max-height: calc(var(--vh) * 80);\n  overflow-y: auto;\n  padding-top: 8px;\n}\n.scheduler[data-v-340aad42] .non-border-input {\n  width: 100%;\n  margin-bottom: 6px;\n}\n.scheduler .scheduler-item[data-v-340aad42] {\n  display: flex;\n  align-items: flex-end;\n  height: auto;\n  margin-top: 14px;\n}\n.scheduler .scheduler-item.checkBoxes[data-v-340aad42] {\n  display: flex;\n  padding-left: 4px;\n}\n.scheduler .scheduler-item.checkBoxes .checkBoxItem[data-v-340aad42] label.custom-checkbox {\n  color: var(--font-color);\n}\n.scheduler .scheduler-item.checkBoxes .checkBoxItem[data-v-340aad42].disabled label.custom-checkbox {\n  cursor: initial;\n  color: var(--placeholder-color);\n}\n.scheduler .scheduler-item.checkBoxes .checkBoxItem.right[data-v-340aad42] {\n  margin-left: 130px;\n}\n.scheduler .scheduler-item .note[data-v-340aad42] {\n  padding-left: 7px;\n  margin-top: 14px;\n  color: var(--placeholder-color);\n}\n.scheduler .scheduler-item .editnote[data-v-340aad42] {\n  white-space: pre-wrap;\n  color: var(--font-color);\n  background-color: var(--bg-color);\n  border: 1px solid var(--list-item-bordercolor);\n  padding: 8px;\n  font-size: 14px;\n  line-height: 1.4em;\n  overflow-y: auto;\n  resize: none;\n  transition: all 0.2s;\n  margin-top: -6px;\n}\n.scheduler .scheduler-item .editnote.disabled[data-v-340aad42] {\n  color: var(--placeholder-color);\n}\n.scheduler .custom-input .custom-input-text[data-v-340aad42] {\n  position: relative;\n  width: 100%;\n}\n.scheduler .repeat-n-reminder[data-v-340aad42] {\n  margin-top: 8px;\n}\n.scheduler .people[data-v-340aad42],\n.scheduler .repeat[data-v-340aad42],\n.scheduler .reminder[data-v-340aad42] {\n  align-items: baseline !important;\n}\n.scheduler .repeat[data-v-340aad42],\n.scheduler .reminder[data-v-340aad42] {\n  flex-direction: column;\n}\n.scheduler .repeat-intervals[data-v-340aad42] {\n  flex-direction: column;\n  align-items: baseline;\n  margin-top: 0px;\n  color: var(--placeholder-color);\n}\n.scheduler .repeat-intervals .label-repeat-intervals[data-v-340aad42] {\n  padding-left: 6px;\n  margin-bottom: -12px;\n  margin-top: 16px;\n}\n.scheduler .repeat-intervals .repeat-calendar[data-v-340aad42] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  padding-left: 24px;\n  padding-bottom: 8px;\n}\n.scheduler .repeat-intervals .repeat-calendar[data-v-340aad42] .date-range-picker {\n  width: 66%;\n  z-index: 1;\n}\n.scheduler .repeat-intervals .repeat-calendar input.interval-input[data-v-340aad42] {\n  color: var(--font-color);\n  background-color: var(--bg-color);\n  transition-property: all;\n  transition-duration: 1s;\n  border: none;\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  padding-left: 6px;\n  width: 36px;\n}\n.scheduler .repeat-intervals .repeat-calendar input.interval-input.disabled[data-v-340aad42] {\n  color: var(--placeholder-color);\n}\n.scheduler .repeat-intervals .repeat-calendar input.interval-input[data-v-340aad42]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--ref-link-color);\n}\n.scheduler .repeat-intervals .repeat-calendar .interval-value-label[data-v-340aad42] {\n  margin-left: 8px;\n  margin-right: 4px;\n}\n.scheduler .repeat-intervals .repeat-options[data-v-340aad42] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: center;\n}\n.scheduler .repeat-options-ext[data-v-340aad42] {\n  margin-top: 16px;\n}\n.scheduler .drpicker[data-v-340aad42] {\n  height: 48px;\n  margin-top: 6px;\n}\n.scheduler .people[data-v-340aad42] {\n  flex-direction: column;\n  margin-top: 0px;\n  height: 48px;\n}\n.scheduler .people .people-label[data-v-340aad42] {\n  padding-left: 6px;\n  line-height: 20px;\n  display: flex;\n  flex-direction: row;\n  font-size: 0.8em;\n  color: var(--placeholder-color);\n}\n.scheduler .people .people-label .lbl-chosen-people[data-v-340aad42] {\n  padding-left: 6px;\n  height: 16px;\n  font-size: 12px;\n}\n.scheduler .people .people-choose[data-v-340aad42] {\n  display: flex;\n  width: 100%;\n}\n.scheduler .people .people-choose input[data-v-340aad42] {\n  color: var(--custom-textarea-color);\n  transition-property: all;\n  transition-duration: 1s;\n  border: none;\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  padding-left: 6px;\n  width: 100%;\n}\n.scheduler .people .people-choose input.disabled[data-v-340aad42] {\n  color: var(--placeholder-color);\n}\n.scheduler .people .people-choose input[data-v-340aad42]:focus {\n  outline: none;\n  border-bottom: 1px solid var(--ref-link-color);\n}\n.scheduler .people .lblBtn[data-v-340aad42] {\n  cursor: pointer;\n  font-size: 24px;\n}\n.scheduler .people .lblBtn.disabled[data-v-340aad42] {\n  cursor: initial;\n}\n.scheduler .people .ctipeople[data-v-340aad42] {\n  height: 28px;\n  width: 383px;\n  margin-right: 14px;\n  background-color: inherit;\n  color: inherit;\n  outline: none;\n}\n.scheduler .subject .custom-input-text[data-v-340aad42] {\n  width: 100%;\n}\n.scheduler .custom-input-text-placeholder[data-v-340aad42] {\n  color: var(--modal-text-color) !important;\n}\n.scheduler .disabled[data-v-340aad42] {\n  cursor: initial;\n  color: var(--placeholder-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
